import { css } from "@emotion/react";
import Header from "./header";
import ResultsList from "./resultsList";
import { useAppContext } from "../../contexts/AppContext";
import { useEffect, useRef, useState } from "react";
import type { SearchHit } from "./algolia";
import { searchBookFragments } from "./algolia";
import { ThemeProvider } from "@emotion/react";
import { theme } from "../../theme";

const CompassInsight = () => {
  const { searchValue } = useAppContext();
  const [searchResults, setSearchResults] = useState<SearchHit[]>([]);
  const timeoutRef = useRef<NodeJS.Timeout | null>(null);

  const invalidSearchTerm =
    !searchValue || searchValue.length < 3 || searchValue.length > 100;

  useEffect(() => {
    if (invalidSearchTerm) {
      return;
    }

    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }

    timeoutRef.current = setTimeout(async () => {
      try {
        const results = await searchBookFragments(searchValue, undefined, []);
        setSearchResults(results.hits);
      } catch (error) {
        if (error instanceof Error && error.message === "Too many requests") {
          // Handle rate limit error gracefully set the results to an empty array and avoid showing an error message
          setSearchResults([]);
          return;
        }
        console.error("Error searching Compass Insight:", error);
        return;
      }
    }, 500);

    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, [searchValue, invalidSearchTerm]);

  if (invalidSearchTerm || !searchResults.length) {
    return null;
  }

  return (
    <ThemeProvider theme={theme}>
      <div
        css={({ colours }) => css`
          width: 716px;
          height: 784px;
          margin: 0 0 0 12px;
          padding: 0 0 12px;
          border-radius: 6px;
          box-shadow:
            0 8px 10px -6px rgba(0, 0, 0, 0.1),
            0 20px 25px -5px rgba(0, 0, 0, 0.1);
          background-color: ${colours.uIGrey.light._0};
        `}
      >
        <Header />
        <ResultsList searchResults={searchResults} />
      </div>
    </ThemeProvider>
  );
};

export default CompassInsight;
